export default __webpack_public_path__ + "static/media/convention27.a7da06bf.png";